import { Component, OnInit } from '@angular/core';
import { Campus } from 'src/app/models/campus.model';
import { School } from 'src/app/models/school.model';
import { SecureStorageService } from 'src/app/services/secure-storage.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-notifications',
  template: `
    <div class="bg-white p-4 rounded-4 shadow">
      <div class="d-flex mb-4">
        <img [src]="environment.ESCALAS_WSPREFIX + (school?.logo?.url || '')" width="18" height="18" class="ms-2" *ngIf="school?.logo">
        <fa-icon [icon]="icons.faChevronRight" class="mx-2" style="font-size: 0.7em; margin-top: 2px;"></fa-icon>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
      <div class="d-flex mb-4">
        <div class="flex-fill">
          <h1>Notificaciones</h1>
          <!-- p>Consulta los condominios.</!-->
        </div>
        <div class="ms-auto">
        <!-- button class="btn btn-outline-primary btn-lg rounded-5 shadow border border-3 border-primary" *ngIf="permissions?.modules.admin.settlements.write" routerLink="/condominios/create/condominio">
        <fa-icon [icon]="faPlus" class="me-2"></fa-icon>
          Agregar
        </!-->
          <!-- button class="btn btn-primary btn-lg rounded-5 ms-3" routerLink="/bills/new">Crear recibo</!-->
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class NotificationsComponent implements OnInit {
  permissions: any = {};
  school: School | null = null;
  campuses: Campus[] = [];
  environment = environment;
  
  constructor(
    public icons: IconsService,
    private readonly secureStorage: SecureStorageService
  ) {}

  ngOnInit(): void {
    this.loadStoredData();
  }

  private async loadStoredData() {
    try {
      this.permissions = await this.secureStorage.getObject('permissions') || {};
      const schoolData = await this.secureStorage.getItem('school');
      this.school = schoolData ? JSON.parse(schoolData) : null;
      this.campuses = await this.secureStorage.getObject<Campus[]>('campuses') || [];
      
      console.log('NotificationsComponent - Data loaded:', { school: this.school, campuses: this.campuses.length });
    } catch (error) {
      console.error('NotificationsComponent - Error loading data:', error);
      this.campuses = [];
      this.school = null;
      this.permissions = {};
    }
  }

}
